/**
 * Bullet Point Component
 * Reusable component for displaying a single bullet point icon
 * Uses the SVG bullet point icon from assets
 * Follows Single Responsibility Principle
 */

import React from 'react';
import Image from 'next/image';

export interface BulletPointProps {
  /**
   * Size of the bullet point icon
   * @default 20
   */
  size?: number;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Custom margin top for alignment
   * @default '4px'
   */
  marginTop?: string | number;
}

/**
 * Bullet Point Component
 * Renders the SVG bullet point icon used consistently across the application
 */
export const BulletPoint: React.FC<BulletPointProps> = ({
  size = 20,
  className,
  marginTop = '4px',
}) => {
  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        marginTop,
        flexShrink: 0,
      }}
      className={className}
    >
      <Image
        src='/assets/images/icons/bullet_point.svg'
        alt=''
        width={size}
        height={size}
        style={{
          objectFit: 'contain',
          display: 'block',
        }}
      />
    </div>
  );
};
